import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import withPermissionProtection from 'hoc/withPermissionProtection';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import Modal from 'components/CncUI/Modal';
import Link from 'components/CncUI/Link';

import useAuthentication from 'hooks/useAuthentication';
import useMutation from 'hooks/useMutation';

import cncCapsMsLogo from 'images/CnCCapsMsLogo.svg';

const useStyles = makeStyles(({ palette }) => ({
  logoImageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.cncUI.default.primary,
    padding: '16px 0px',
  },
  paddedTop: {
    paddingTop: '16px',
  },
}));

const MPN_LINK =
  'https://www.castandcrew.com/wp-content/uploads/2019/12/MPN_DWCF-Form-9783-Combined-Bilingual.pdf';
const MPN_EMAIL = 'MPN@castandcrew.com';

const MedicalProviderNetworkDialog = () => {
  const classes = useStyles();
  const { refresh } = useAuthentication();
  const mutate = useMutation('acceptMedicalProviderNetwork');
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      open
      id="MedicalProviderNetwork"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <Modal.Content>
        <div className={classes.logoImageHeader}>
          <img alt="logo" align="center" src={cncCapsMsLogo} />
        </div>
        <Typography variant="h5" align="center" className={classes.paddedTop}>
          Medical Provider Network
        </Typography>
        <Typography variant="body2" size="long" className={classes.paddedTop}>
          Attention all California, USA employees: Cast & Crew has established a
          Medical Provider Network (MPN) for all work-related
          injuries/illnesses. In the event of an injury, your care will be
          directed to a physician within the MPN. You have the right to
          pre-designate a doctor. For further information, please visit{' '}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            key="medicalProviderNetwork-a"
            href={MPN_LINK}
          >
            Medical Provider Network
          </Link>{' '}
          or email{' '}
          <Link
            href={`mailto:${MPN_EMAIL}`}
            target="_blank"
            rel="noopener noreferrer"
            key="medicalProviderNetwork-mailto"
          >
            {MPN_EMAIL}
          </Link>
        </Typography>
      </Modal.Content>
      <Modal.Actions>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button
              id={'MedicalProviderNetwork-AcceptButton'}
              loading={loading}
              onClick={() => {
                setLoading(true);
                mutate().then(() => refresh());
              }}
            >
              I Acknowledge
            </Button>
          </Grid>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

export default withPermissionProtection('openid')(MedicalProviderNetworkDialog);
